import { h } from 'preact';
import React, { Component } from 'react';
import Main from './Main/Main';
import Vendors from './Vendors/Vendors';
import { PMTCFv2InlineSettings } from './PMTCFv2InlineSettings';
import './PMTCFv2Inline.css';
import { makeText, formatDescription } from '../../util';

export class PMTCFv2Inline extends Component {
  state = {
    page: this.props.pmTab
      ? this.props.pmTab.includes('li')
        ? 'li'
        : this.props.pmTab.includes('purposes')
          ? 'purposes'
          : 'vendors'
      : this.props.message.defaultTab || 'purposes',
    loading: true
  }

  backRef = React.createRef()

  changePage = (page) => {
    this.setState({ page }, () => {
      if (this.backRef.current) {
        this.backRef.current.focus();
      };
    });
  }

  linkHover = (e, which) => {
    e.target.style.color = which.color;
    e.target.style.textDecoration = which.textDecoration;
    e.target.style.fontWeight = which.fontWeight;
  }
  render() {
    const Settings = new PMTCFv2InlineSettings(this.props.component.settings);
    const { language } = this.props;
    let { page } = this.state;

    const data = this.props.pmData || {};

    /* DEV MODE ONLY */
    let devActions = {}, selected = false, path = JSON.stringify(this.props.path);
    if (this.props.dev) {
      devActions = { ...this.props.dev.hover };
      selected = this.props.dev.current === path;
    }

    const sectionStyles = {};
    sectionStyles.minHeight = Settings.minHeight.type === 'auto' ? 'auto' : Settings.minHeight.value + Settings.minHeight.type;
    sectionStyles.maxHeight = Settings.maxHeight.type === 'auto' ? 'auto' : Settings.maxHeight.value + Settings.maxHeight.type;
    const accordionStyles = { ...Settings.accordionsFont };
    const linkAttributes = {
      style: Settings.link,
      onMouseOver: (e) => this.linkHover(e, Settings.hover),
      onMouseOut: (e) => this.linkHover(e, Settings.link)
    };
    const className = 'message-component message-stacks pm-tcfv2-inline no-children' + this.props.className;

    const liText = makeText(Boolean(this.props.dev), Settings, 'liText', language);
    const liInfo = makeText(Boolean(this.props.dev), Settings, 'liInfo', language);
    const vendorsText = makeText(Boolean(this.props.dev), Settings, 'vendorsText', language);
    const vendorsInfo = makeText(Boolean(this.props.dev), Settings, 'vendorsInfo', language);
    const customPurposesText = makeText(Boolean(this.props.dev), Settings, 'customPurposesText', language);
    const customPurposesLetter = makeText(Boolean(this.props.dev), Settings, 'customPurposesLetter', language);

    const useStacks = this.props.message.useStacks;
    const consentOnlyStacks = this.props.message.consentOnlyStacks;
    const usePurModel = this.props.message.usePurModel;
    const vendorList = data.vendors || [];
    if (Settings.alphabetizeVendors) {
      vendorList.sort((a, b) =>{
        if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
        if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
        return 0;
      });
    }

    return (
      <div
        ref={this.backRef}
        className={selected ? className + ' on-active' : className}
        path={path} {...devActions}
      >

        {page === 'purposes' && data.categories !== undefined && data.features !== undefined && (
          <div className="pm-section pm-main" style={sectionStyles}>
            <Main
              dev={this.props.dev}
              stacks={data.stacks || []}
              purposes={data.categories || []}
              specialFeatures={data.specialFeatures || []}
              features={data.features || []}
              specialPurposes={data.specialPurposes || []}
              useStacks={useStacks}
              consentOnlyStacks={consentOnlyStacks}
              language={this.props.language}
              settings={Settings}
              togglePurposeOrFeature={this.props.togglePurposeOrFeature}
              toggleStack={this.props.toggleStack}
              selected="consent"
              usePurModel={usePurModel}
            />
            <div className="page-link bottom">
              <div className="page-desc" style={accordionStyles}>{liInfo}</div>
              <div
                tabIndex="0"
                className="page-action"
                {...linkAttributes}
                onClick={() => this.changePage('li')}
                onKeyDown={(e) => e.keyCode == 13 && this.changePage('li')}
              >
                {liText}
              </div>
            </div>
            <div className="page-link bottom">
              <div className="page-desc" style={accordionStyles}>{vendorsInfo}</div>
              <div
                tabIndex="0"
                className="page-action"
                {...linkAttributes}
                onClick={() => this.changePage('vendors')}
                onKeyDown={(e) => e.keyCode == 13 && this.changePage('vendors')}
              >
                {vendorsText}
              </div>
            </div>
            <div className="legend"><span className="legend-key">{customPurposesLetter}</span> {customPurposesText}</div>
          </div>
        )}

        {page === 'li' && data.vendors !== undefined && (
          <div className="pm-section pm-li" style={sectionStyles}>
            <div id="li-header" className="page-header">
              <div
                ref={this.backRef}
                tabIndex="0"
                className="chevron left"
                onClick={() => this.changePage('purposes')}
                onKeyDown={(e) => e.keyCode == 13 && this.changePage('purposes')}
              />
              {liText}
            </div>
            <p style="margin-bottom:15px;" className="page-information">{formatDescription(liInfo)}</p>
            <Main
              dev={this.props.dev}
              stacks={data.stacks || []}
              purposes={data.categories || []}
              specialFeatures={data.specialFeatures || []}
              useStacks={useStacks}
              consentOnlyStacks={consentOnlyStacks}
              language={this.props.language}
              settings={Settings}
              togglePurposeOrFeature={this.props.togglePurposeOrFeature}
              toggleStack={this.props.toggleStack}
              selected="li"
            />
          </div>
        )}

        {page === 'vendors' && data.vendors !== undefined && (
          <div className="pm-section pm-vendors" style={sectionStyles}>
            <div id="vendors-header" className="page-header">
              <div
                ref={this.backRef}
                tabIndex="0"
                className="chevron left"
                onClick={() => this.changePage('purposes')}
                onKeyDown={(e) => e.keyCode == 13 && this.changePage('purposes')}
              />
              {vendorsText}
            </div>
            <p style="margin-bottom:15px;" className="page-information">{formatDescription(vendorsInfo)}</p>
            <Vendors dev={this.props.dev} vendors={data.vendors || []} settings={Settings} language={this.props.language} toggleVendor={this.props.toggleVendor} usePurModel={usePurModel}/>
          </div>
        )}

      </div>
    );
  }
}
